import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";
import "./Layout.css";

const Layout = ({ type }) => {
  return (
    <div className="layout">
      <Header type={type} />
      <div className="main">
        <Sidebar type={type} />
        <div className="content-layout">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
